<template>
  <div class="rate_item">
    <div class="rate_creater">
      <span>{{reviewer ? `评价人：${reviewer}` : '匿名'}}</span>
      <span>{{date}}</span>
    </div>
    <p class="rate_content">付款速度{{payment_speed}}分 &nbsp; 过户速度{{transfer_speed}}分 &nbsp; 车商专业{{dealer_professional}}分</p>
    <p class="rate_mark">{{content || '您未填写评价内容'}}<span v-if="review_type === 1">(交易后的30天内未评价默认好评)</span></p>
    <div
      class="rate_pic"
      v-if="images.length > 0"
    >
      <img
        v-for="(item, index) in images"
        :src="item.src"
        :key="index"
        @click="clickSwiper(index)"
      >
    </div>
    <images-previewer
      :list="images"
      :w='600'
      :h='400'
      ref="previewer"
    ></images-previewer>
  </div>
</template>
<script>
// import { Previewer } from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'
export default {
  components: {
    // Previewer
    ImagesPreviewer
  },
  props: {
    reviewer: {
      type: String,
      default: ''
    },
    showDate: {
      type: Boolean,
      default: true
    },
    showImage: {
      type: Boolean,
      default: true
    },
    date: String,
    payment_speed: {
      type: [Number, String],
      default: 0
    },
    review_type: {
      type: Number,
      default: 0
    },
    content: {
      type: String,
      default: ''
    },
    transfer_speed: {
      type: [Number, String],
      default: 0
    },
    dealer_professional: {
      type: [Number, String],
      default: 0
    },
    images: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    clickSwiper(i) {
      this.$refs.previewer.show(i)
    }
  }
}

</script>
<style scoped lang="less">
@import '../../stylesheets/base/fn.less';

.rate_item {
  margin-bottom: 20 / @w2;
  padding: 30 / @w2;
  background-color: #fff;
  font-size: 28 / @w2;

  .rate_creater {
    color: #999;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .rate_content {
    padding-top: 16 / @w2;
    color: #333;
  }

  .rate_mark {
    padding-top: 16 / @w2;
    color: #666;
    span{
      margin-left: 20/@w2;
      color: #6A6A6A;
    }
  }

  .rate_pic {
    padding-top: 16 / @w2;
    height: 160 / @w2;
    display: flex;
    margin-left: -2%;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    overflow: hidden;
    img {
      display: inline-block;
      box-sizing: border-box;
      width: 23%;
      margin-left: 2%;
    }
  }
}
</style>
